module.exports = __webpack_public_path__ + "static/img/son1.974706da.png";